import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Config } from '@leverege/plugin'
import { TwoFactorPane } from '@leverege/api-ui-login'
import { Content, Flex, Pane, Text } from '@leverege/ui-elements'
import { GlobalState } from '@leverege/ui-redux'
import { Users } from '@leverege/api-redux'
import { TitleBar } from '@leverege/ui-plugin'
import ChangePasswordForm from './ChangePasswordForm'

function ProfileScreen( props ) {
  const { user, profile } = props
  const [ project2FASettings, setProject2FASettings ] = useState()
  const [ changePasswordKey, setChangePasswordKey ] = useState( Date.now() )

  const onSetChangePasswordKey = useCallback( () => {
    setChangePasswordKey( Date.now() )
  }, [] )

  useEffect( () => {
    const loadSettings = async () => {
      const settings = await GlobalState.dispatch( ( dispatch, getState, { api } ) => {
        return api
          .project( profile.projectId || 'shared' )
          .twoFactorSettings()
          .get()
      } )
  
      await GlobalState.dispatch( Users.get( profile.id ) )
  
      setProject2FASettings( settings )
    }

    if ( profile ) {
      loadSettings()
    }
  }, [ profile ] )

  return (
    <Content>
      <Content.Header>
        <TitleBar variant="screenTitle" title="Profile" />
      </Content.Header>
      <Content.Area>
        <Flex variant="colL" style={{ maxWidth : '704px' }}>
          <Pane layout="flex:colL">
            <TwoFactorPane
              project2FASettings={project2FASettings}
              profile={user} />
            <Pane layout="flex:colL" variant="contentSection">
              <Flex variant="setting|colM">
                <Text variant="sectionTitle|title">
                  Change Password
                </Text>
                <Text variant="sectionBody|subtitle">
                  Enter your current password to update your current password. It&apos;s best to use a strong password that you aren&apos;t using elsewhere.
                </Text>
              </Flex>
              <ChangePasswordForm key={changePasswordKey} onSubmit={onSetChangePasswordKey} />
            </Pane>
          </Pane>
        </Flex>
      </Content.Area>
    </Content>
  )
}

export default connect( ( state, props ) => {
  const userId = state.auth?.profile?.id

  return {
    profile : state.auth.profile,
    user : state.apiReduxUsers.lookup[userId]
  }
} )( ProfileScreen )
